var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-container"},[(_vm.isAuthenticated)?[_c('div',{staticClass:"main-layout"},[_c('div',{staticClass:"main-layout-navbar"},[_c('Navbar')],1),_c('div',{staticClass:"main-layout-content"},[_c('Content',[_c('router-view')],1)],1)])]:[_c('Loading')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }